import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/picture';
const list = () => {
	return Client.get('/admin/api/picture');
};
const listCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}`);
};

const update = (metaId, payload) => {
	return Client.put(`/admin/api/picture/${metaId}`, payload);
};

const remove = (metaId) => {
	return Client.del(`/admin/api/picture/${metaId}`);
};
const removeCloud = (merchantId, branchId, metaId) => {
	return Client.del(`${numbatUrl}/${merchantId}/${branchId}/${metaId}`);
};
const sort = (sortedList) => {
	return Client.put(`/admin/api/picture/arrange`, sortedList);
};
const sortCloud = (merchantId, branchId, sortedList) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/arrange`,
		sortedList
	);
};
const upload = (payload) => {
	return Client.post(
		`/admin/api/picture/form`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};
const uploadCloud = (merchantId, branchId, payload) => {
	return Client.post(
		`${numbatUrl}/${merchantId}/${branchId}/form`,
		payload,
		{},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export default {
	list,
	update,
	remove,
	sort,
	upload,
	listCloud,
	removeCloud,
	sortCloud,
	uploadCloud,
};
